import { inject, Injectable } from '@angular/core';
import { MessageService } from '@openng/optimus-ui/api';
import { NotificationType } from 'src/app/shared/data/enums/notification.types';
import { NotificationMessageOptions } from 'src/app/shared/data/models/notification-message-options.model';

@Injectable({
	providedIn: 'root',
})
export class NotificationService {
	private messageService = inject(MessageService);

	info(message: NotificationMessageOptions) {
		this.show(NotificationType.Info, this.messageWithDefault(message, 'Informacija'));
	}
	success(message: NotificationMessageOptions) {
		this.show(NotificationType.Success, this.messageWithDefault(message, 'Sėkmė'));
	}
	warning(message: NotificationMessageOptions) {
		this.show(NotificationType.Warn, this.messageWithDefault(message, 'Perspėjimas'));
	}
	error(message: NotificationMessageOptions) {
		this.show(NotificationType.Error, this.messageWithDefault(message, 'Klaida'));
	}

	show(type: NotificationType, message: NotificationMessageOptions) {
		this.messageService.add({
			severity: type,
			summary: message.title,
			detail: message.message,
			life: this.getNotificationDuration(type),
		});
	}

	private messageWithDefault(message: NotificationMessageOptions, defaultTitle: string) {
		return {
			...message,
			title: message.title ?? defaultTitle,
		};
	}

	private getNotificationDuration(type: NotificationType) {
		let duration = 5;

		if (type === NotificationType.Warn || type === NotificationType.Info) {
			duration = 10;
		} else if (type === NotificationType.Error) {
			duration = 15;
		}

		return duration * 1000;
	}
}
